module.exports = __webpack_public_path__ + "media/assets/img/flags/hi-IN-78cbfbf0381b8c7f5a192c4a46bd0b0e.png";